subscription ContentStreamStatusChanged($id: ID!) {
  contentStreamStatusChanged(id: $id) {
    id
    stream {
      id
      status
      liveConnected
      signal {
        state
        since
        checkedAt
      }
      lastError {
        code
        message
      }
      pull {
        sourceUrl
        status
        attempt
        maxAttempts
        startedAt
        finishedAt
        lastError {
          code
          message
        }
      }
    }
  }
}
